module.exports = __webpack_public_path__ + "img/Digital-initiatives-600x400.17163164.png";